import { CommonsCapacities, } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class CommonsCapacitiesAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    get contact_name() {
        return capitalizeString(this.value.contact_name || '');
    }

    get contact_email() {
        return this.value.contact_email || '';
    }

    adapt(): CommonsCapacities {
        return {
            id: this.value.id,
            area_de_conocimiento: this.value.area_de_conocimiento.AREA_DE_CONOCIMIENTO,
            especialidad_de_conocimiento: this.value.especialidad_de_conocimiento.ESPECIALIDAD_DE_CONOCIMIENTO,
            gran_area_de_conocimiento: this.value.gran_area_de_conocimiento.GRAN_AREA_DE_CONOCIMIENTO,
            descripcion: this.value.descripcion,
            beneficiario: this.value.beneficiario,
            beneficios_que_genera: this.value.beneficios_que_genera,
            capacity_type: this.value.capacity_type,
            caracteristicas_de_productos_yo_servicios_que_genera: this.value.caracteristicas_de_productos_yo_servicios_que_genera,
            descripcion_detallada: this.value.descripcion_detallada,
            grado_de_madurez_de_la_solucion_capacidad: this.value.grado_de_madurez_de_la_solucion_capacidad,
            identidad: this.value.identidad,
            presupuesto: this.value.presupuesto,
            problemas_que_soluciona: this.value.problemas_que_soluciona,
            external_code: this.value.external_code,
            nombre: capitalizeString(this.value.nombre || '')
        }
    }
}
